import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { extensionS1Mixin } from '../mixins/index';
import { required } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import { createExtensionService } from '../../../helper-functions/services';
import { onlyAlphaNumeric, monthDate, numbersWithDashSlash, noAlphabets } from '../../../helper-functions/helper-functions';

Vue.use(Vuelidate);

export default {
    components:{
        'date-picker': datePicker
    },
    mixins:[MainVueOpts, extensionS1Mixin],
    validations: function() {
        const validations = {
            form:{
                certificateNumber: {
                    required,
                    onlyAlphaNumeric
                },
                birthDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                }
            }
        };

        return validations;
    },
    mounted() {
        if (ibJS.extensionErrors) {
            this.$emit('backenderrors', ibJS.extensionErrors);
        }
    },
    methods: {
        submitForm: function (e) {
            if(e) e.preventDefault();

            this.$v.$touch();

            if (this.captchaIsIncomplete()) return;

            if (!this.$v.$invalid) {
                let spinTarget=this.$refs.btnspinner;
                let spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);
                this.formSending = true;
                let urlLang = '/travel-and-student-insurance-extension/';
                switch(window.globalLanguage.lang) {
                    case'en' :
                        urlLang = '/travel-and-student-insurance-extension/';
                        break;
                    case'es' :
                        urlLang = '/seguro-de-viaje-y-de-estudiante-prorroga/';
                        break;
                    case'zh' :
                        urlLang = '/lvyou-he-xuesheng-baoxian-yanchang/';
                        break;
                }
                let url = '/api'+urlLang;
                let data = JSON.stringify(this.form);
                this.resetCaptcha();
                createExtensionService.call(this, url, data, 'extension');

            } else {
                this.showMobileError = true;
            }
        },
        showResetApplicationModal() {
            this.resetForm('worldtrips-extension');
        }
    }
};
